import React, { FC, useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { PageTitle } from '../../../../_metronic/layout/core'
import Select from 'react-select';
import { fetchData, getTranslatedValue, toasterrormsg } from '../../../../reusable';
import { ToastContainer } from 'react-toastify';
import moment from 'moment';
import { Calendar, momentLocalizer } from 'react-big-calendar';
import 'react-big-calendar/lib/css/react-big-calendar.css';
import Loader from '../../component/Loader';
import { Tr } from '../../../../_metronic/i18n/Tr';
import { useLang } from '../../../../_metronic/i18n/Metronici18n';

const ViewTourInventory: FC = () => {

  const t = Tr()
  const lang = useLang()
  const navigate = useNavigate()
  const categoryId = sessionStorage.getItem('categoryId');
  useEffect(() => {
    if (categoryId != '5') {
      navigate('../dashboard/');
    }
  }, [categoryId])

  var vendorId = "";
  const vendorData = sessionStorage.getItem("vendor");
  if (vendorData) {
    var vendor = JSON.parse(vendorData);
    vendorId = vendor.vendorId;

  } else {
    console.log("No vendor data found");
  }
  // sub category list state start
  const [tourTypeList, setTourTypeList] = useState([]);
  const [tourTypeSelectedOptions, setTourTypeSelectedOptions] = useState<any>();
  // sub category list state end
  // inventory list state start
  const [invetoryList, setInvetoryList] = useState([]);
  const [invetorySelectedOptions, setInvetorySelectedOptions] = useState<any>();
  const [calanderDate, setCalanderDate] = useState(new Date());

  // inventory list state end
  const [isLoading, setIsLoading] = useState(false);

  // ------------------- for schedule calander -------------------------
  const localizer = momentLocalizer(moment);

  interface CustomEvent {
    start: Date;
    end: Date;
    title: string;
    allDay: Boolean;
  }
  const [events, setEvents] = useState<CustomEvent[]>([]);

  const eventStyleGetter = (event: any) => {
    let backgroundColor = event.title.includes(t('Available')) ? 'green' : 'red';
    let style = {
      backgroundColor: backgroundColor,
      borderRadius: '5px',
      opacity: 0.8,
      color: 'white',
      border: '0px',
      display: 'block'
    };
    return {
      style: style
    };
  };

  //   tour type List list api call
  const tourtypeListAPIcall = async () => {

    const param = {
      categoryId: categoryId,
      vendorId: vendorId
    }
    var res = await fetchData("public/vendorWiseInventoryTypes", param)

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.tourtypeId, label: getTranslatedValue(lang, val, '_name') })
      })
      setTourTypeList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  // hotel Room list api call
  const invetoryTypeListApiCall = async (id: string) => {

    const param = {
      actionTypeId: String(id),
      vendorId: String(vendorId),
      categoryId: '5'
    }

    var res = await fetchData("public/inventoryTypeList", param)

    if (res.status == "200") {
      var opt: any = []
      res.data.map((val: any) => {
        opt.push({ value: val.toursId, label: getTranslatedValue(lang, val, '_name') })
      })
      // console.log(res.data);
      
      setInvetoryList(opt)
    }
    else {
      toasterrormsg(res.message)
    }
  }
  //   invetory Availability Date list api call
  const invetoryAvailabilityDate = async () => {
    setIsLoading(true)
    var param = {
      actionTypeId: invetorySelectedOptions ? String(invetorySelectedOptions.value) : "",
      typeId: tourTypeSelectedOptions ? String(tourTypeSelectedOptions.value) : "",
      vendorId: String(vendorId),
      categoryId: String(categoryId),
      monthYear: moment(calanderDate).format('YYYY-MM')
    }
    var res = await fetchData("public/invetoryAvailabilityDate", param)

    if (res.status == "200") {
      setIsLoading(false)
      const transformedEvents: CustomEvent[] = res.data.flatMap((item: any) => [
        {
          title: `${t('Available')} ${item.available}`,
          start: new Date(item.date),
          end: new Date(item.date),
          allDay: true
        },
        {
          title: `${t('Booked')} ${item.booked}`,
          start: new Date(item.date),
          end: new Date(item.date),
          allDay: true
        }
      ]);
      // Set the events state
      setEvents(transformedEvents);

    } else {
      toasterrormsg(res.message)
    }
  }
  useEffect(() => {
    tourtypeListAPIcall();
  }, [])
  useEffect(() => {
    if ((tourTypeSelectedOptions && tourTypeSelectedOptions.value) || (invetorySelectedOptions && invetorySelectedOptions.value)) {
      invetoryAvailabilityDate();
    }
  }, [tourTypeSelectedOptions, invetorySelectedOptions, calanderDate])
  return (
    <>
      {isLoading && (<Loader />)}
      <ToastContainer />
      <PageTitle breadcrumbs={[]}>{t('Inventory Management')}</PageTitle>
      <div className="d-flex flex-column flex-column-fluid">
        {/* <!--begin::Content--> */}
        <div id="kt_app_content" className="app-content flex-column-fluid">
          {/* <!--begin::Form--> */}
          <div className="form d-flex flex-column flex-lg-row">
            {/* <!--begin::Main column--> */}
            <div className="d-flex flex-column flex-row-fluid gap-7 gap-lg-10">
              {/* <!--begin::Tab content--> */}
              <div className="tab-content">
                {/* <!--begin::Tab pane--> */}
                <div className="tab-pane fade show active" id="kt_ecommerce_add_product_general" role="tab-panel">

                  <div className="d-flex flex-column">
                    {/* <!--begin::General options--> */}
                    <div className="card card-flush pt-4">
                      {/* <!--begin::Card header--> */}
                      <div className="card-header d-flex">
                        {/* <!--begin::Card title--> */}
                        <div className="card-title">
                          <h2>{t('Inventory Management')}</h2>
                        </div>
                        {/* <!--end::Card title--> */}
                      </div>
                      {/* <!--end::Card header--> */}
                      {/* <!--begin::Card body--> */}
                      <div className="card-body pt-0">
                        {/* <!--begin::Input group--> */}
                        <div className="row">
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="required fs-4 form-label">{t('Tour Type')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='tourType[]'
                              id='tourTypeListId'
                              placeholder={t('Select Tour Type')}
                              isSearchable={true}
                              options={tourTypeList}
                              value={tourTypeSelectedOptions}
                              onChange={(e: any) => { setTourTypeSelectedOptions(e); setInvetorySelectedOptions(undefined); invetoryTypeListApiCall(e.value); }}
                            />
                            {/* <!--end::Input--> */}
                          </div>
                          <div className="col-lg-4 my-3">
                            {/* <!--begin::Label--> */}
                            <label className="fs-5 form-label">{t('Tour')}</label>
                            {/* <!--end::Label--> */}
                            {/* <!--begin::Input--> */}
                            <Select
                              name='invetoryList'
                              id='invetoryList'
                              placeholder={t('Select Tour')}
                              isSearchable={true}
                              options={invetoryList}
                              value={invetorySelectedOptions || ''}
                              onChange={(e: any) => { setInvetorySelectedOptions(e); }}
                            />
                            {/* <!--end::Input--> */}
                          </div>
                          <div className="col-lg-12 my-5">
                            <Calendar
                              localizer={localizer}
                              events={events}
                              startAccessor="start"
                              endAccessor="end"
                              style={{ height: 500 }}
                              eventPropGetter={eventStyleGetter}
                              onNavigate={(date) => {
                                setCalanderDate(date)
                              }}
                            />
                          </div>
                        </div>
                        {/* <!--end::Input group--> */}
                      </div>
                      {/* <!--begin::Card body--> */}
                    </div>
                    {/* <!--end::Pricing--> */}
                  </div>
                </div>
                {/* <!--end::Tab pane--> */}
              </div>
              {/* <!--end::Tab content--> */}
            </div>
            {/* <!--end::Main column--> */}
          </div>
          {/* <!--end::Form--> */}
        </div>
        {/* <!--end::Content--> */}
      </div>
    </>
  )
}

export { ViewTourInventory }
